import { ReactNode } from "react";

type Props = {
approveAction: () => void | Promise<void>;
cancelAction: () => void | Promise<void>;
btnApproveTitle?: string;
btnCancelTitle?: string;
children?: ReactNode; 
popupType?:number;
title:string;
size?:string;
btnIcon?:string;
};
 
const PopupGlobel=({
  approveAction,
  cancelAction,
  btnApproveTitle,
  btnCancelTitle,
  children ,
  popupType=1,
  title,
  size='lg',
  btnIcon='save'
}: Props) => {
  return (
    <>
      <div
        className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50"
        onClick={cancelAction}
      >
        {/* Prevent clicking inside popup from closing it */}
        <div
          className={`relative z-50 w-full max-w-${size} bg-surface rounded-[24px] shadow-xl overflow-hidden flex flex-col max-h-[85vh] md:max-h-[75vh]`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center  gap-4 p-6 bg-surface-container-low">
            <div className={"w-12 h-12 rounded-full "+(popupType===1?"bg-primary":"bg-error")+" flex items-center justify-center shrink-0"}>
              <span className="material-symbols-outlined text-on-primary text-[24px]">
                gavel
              </span>
            </div> 
            <div>
              <h2 className="font-headline-md text-headline-md text-on-surface">
                 {title}
              </h2> 
            </div> 
            {/* Close X */}
            <button
              type="button"
              onClick={ cancelAction}
              className="mr-auto w-10 h-10 rounded-full hover:bg-surface-variant flex items-center justify-center transition-colors"
            >
              <span className="material-symbols-outlined text-on-surface-variant">
                close
              </span>
            </button>
          </div>
 
          {/* Content */}
          <div className="p-3 overflow-y-auto flex-1 font-body-md text-body-md text-on-surface/80 space-y-6">
                   {children}
           </div>
 
          {/* Footer */}
          <div className="p-3 bg-surface-container-low shadow-[0_-4px_12px_rgba(0,0,0,0.03)]">
            {/* Buttons */}
            <div className="flex items-center justify-end gap-4">
                   {/* approve */}
                    <button
                    type="button"
                      className={"flex-1 sm:flex-none px-8 h-13 py-3 rounded-full "+(popupType===1?"bg-primary text-on-primary":"bg-error text-on-error")+"  font-bold text-label-md shadow-lg shadow-vibrant-orange/25 hover:shadow-xl transition-all flex items-center justify-center gap-3 group"}
                     onClick={ approveAction}
                    >
                      <span>    {btnApproveTitle}</span>
                      <span className="material-symbols-outlined text-2xl group-hover:-translate-x-1 group-hover:-translate-y-0.5 transition-transform">
                        {btnIcon}
                      </span>
                    </button>
              {/* <button
                type="button"
                onClick={ approveAction}
                className={"rounded-full shadow-sm  "+(popupType===1?"bg-primary text-on-primary":"bg-error text-on-error")+"  font-label-md px-6 py-2 hover:bg-primary/90 transition-al"}
              >
             <span className="material-symbols-outlined text-2xl group-hover:-translate-x-1 group-hover:-translate-y-0.5 transition-transform">
                        send
                      </span>
                {btnApproveTitle}
               

              </button> */}
              {/* Close */}
              <button
                type="button"
                onClick={ cancelAction}
                className="px-6 py-3 rounded-full font-label-md text-label-md surface-container-low text-on-surface hover:bg-surface-variant transition-colors shadow-sm"
              >
                {btnCancelTitle}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupGlobel;

